import { render, staticRenderFns } from "./GenericCheckbox.vue?vue&type=template&id=0b1240c4&"
import script from "./GenericCheckbox.vue?vue&type=script&lang=js&"
export * from "./GenericCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports